import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { ContactsV2 } from 'src/models/DTO/contact/contactsV2';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { OrderInfo } from 'src/models/DTO/orders/orderInfo';
import { UserDTO } from 'src/models/DTO/user/user';
import { ContactService } from 'src/services/request/contact/contact.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';

@Component({
  selector: 'app-orderaddress',
  templateUrl: './orderaddress.component.html',
  styleUrls: ['./orderaddress.component.css']
})
export class OrderaddressComponent extends HistoryBaseComponent implements OnInit {

  selectedContact?: PlainContactV2;
  
  private _contactType: string = '';
  private _order?: OrderInfo;
  private _contacts: ContactsV2 = { data: [] };
  private _loggedUser?: UserDTO;
  private _title = "Моите адреси";
  private _btnText = "Добави нов адрес";


  constructor(
    private contactService: ContactService,
    private orderStateService: OrederStateService,
    private loggedUserService: LoggedUserService, 
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this._pageTitle = "address_select";
    this.orderStateService.orderInfo$.subscribe(orederInfo => {
      this._order = orederInfo;
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._contactType = params.type;
      this.setTitle();
      this.setBtnText();
      this.loggedUserService.userInfo$.subscribe((user) => {
        if (Object.keys(user).length) {
          this._loggedUser = user;
          this.getCurrentAddresses();
        }
      });
    })
  }

  private getCurrentAddresses() {
    this._contacts.data = [];
    if (this._contactType == Config.invoice) {
      this.contactService.getContactsForEntity().subscribe((response) => {
        this._contacts.data.push(...response.data.filter(contact => contact.type.label == Config.invoiceUserLocationRole || contact.type.label == Config.invoiceCompanyLocationRole));
        if (this._order?.invoiceContactUUID) {
          this.selectedContact = this._contacts.data.find(contact => contact.uuid == this._order?.invoiceContactUUID)
        }
        else {
          this.selectedContact = this._contacts.data[this._contacts.data.length - 1];
        }
      })
    }
    else if (this._contactType == Config.shipping) {
      this.contactService.getContactsForEntity().subscribe((response) => {
        this._contacts.data.push(...response.data.filter(contact => contact.type.label == Config.userLocationRole));
        if (this._order?.contactUUID) {
          this.selectedContact = this._contacts.data.find(contact => contact.uuid == this._order?.contactUUID)
        }
        else {
          this.selectedContact = this._contacts.data[this._contacts.data.length - 1];
        }
      })
    }
  }

  get addresses() {
    return this._contacts.data;
  }

  get title() {
    return this._title;
  }

  get btnText() {
    return this._btnText;
  }
  


  private setTitle() {
    if (this._contactType == Config.invoice) {
      this._title = "Данни за фактура";
    }
    else {
      this._title = "Моите адреси";
    }
  }

  private setBtnText() {
    if (this._contactType == Config.invoice) {
      this._btnText = "Добави нови данни";
    }
    else {
      this._btnText = "Добави нов адрес";
    }
  }

  private getCompanyNumberDetails(address: PlainContactV2) {
    let companyInfo = ', ' + address.company_number;
    if (address.company_vat_number) {
      companyInfo += ', ' + address.company_vat_number
    }
    companyInfo += ', ' + address.company_owner;
    return companyInfo
  }

  choose() {
    if (this._contactType == Config.invoice) {
      // if (userType)
      this._order!.invoiceContactUUID = this.selectedContact!.uuid;
      this._order!.invoiceAddressName = this.getNameAsString(this.selectedContact!);
      this._order!.invoiceAddress = this.getAddressString(this.selectedContact!);
      this._order!.invoiceCity = this.selectedContact!.city;
      this._order!.invoicePhone = this.getTelAsString(this.selectedContact!);
      this._order!.invoiceCounty = this.selectedContact!.country.name;
      this._order!.invoicePostcode = this.selectedContact!.post_code;
      this.orderStateService.addNewOrderInfo(this._order!);
      // if (compType)
      // Nothing
    }
    else if (this._contactType == Config.shipping) {
      this._order!.toAddress = true;
      this._order!.toCarrierOffice = false;
      this._order!.contactUUID = this.selectedContact!.uuid;
      this._order!.addressName = this.selectedContact?.name;
      this._order!.address = this.getAddressString(this.selectedContact!);
      this._order!.phone = this.getTelAsString(this.selectedContact!);
      this._order!.city = this.selectedContact!.city;
      this._order!.country = this.selectedContact!.country.name;
      this._order!.postcode = this.selectedContact!.post_code;
      this.orderStateService.addNewOrderInfo(this._order!);
    }
    this.goToOrder();
  }

  createAddress() {
  this.router.navigate(['order/adderess/edit/' + this._contactType])
  }

  goToOrder() {
    this.router.navigate(['order/details'])
  }

  getAddressString(address: PlainContactV2) {
    if (Config.invoiceCompanyLocationRole == address.type.label) {
      return address.city + ', ' + address.address_line_2 + ', ' + address.post_code;
    }
    return address.street_name + ' ' 
            + address.street_number + ', ' 
            + ((address.address_line_2) ? (address.address_line_2 + ', ') : '')
            + address.city + ', ' 
            + ((address.post_code) ? address.post_code : '')
  }

  getNameAsString(address: PlainContactV2) {
    if (Config.invoiceCompanyLocationRole == address.type.label) {
      return address.company_name || ''
    }
    return address.name || '';
  }

  getTelAsString(address: PlainContactV2) {
    if (Config.invoiceCompanyLocationRole == address.type.label) {
      return this.getCompanyNumberDetails(address);
    }
    return address.mobile_phone_1_e164;
  }

  back() {
    this.router.navigate(['order/details']);
  }

  editAddress(address: PlainContactV2) {
    this.router.navigate(['order/adderess/edit/' + this._contactType + '/' + address.uuid]);
  }
}
